import * as React from 'react';
const throttle = require('lodash.throttle');
import * as styles from './styles.css';

import { Button } from '@cian/ui-kit';

import { NBSP } from '../../constants/symbols';
import { Text } from '../Text';
import { Container } from '../Container';

import excel from './assets/icons/excel.svg';
import { trackDownloadClick, trackLeaveClick } from './tracking';

export interface IHeroProps {
  isVisibleStickHeader: boolean;
  isVisibleStickBottom: boolean;
  feedbackTopPosition: number;
  feedbackHeight: number;
  isVisibleForm: boolean;

  setVisibleStickHeader(visible: boolean): void;
  setVisibleStickBottom(visible: boolean): void;
  scrollToFeedback(): void;
}

export class Hero extends React.Component<IHeroProps, {}> {
  private controlsRef = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    return (
      <div className={styles['container']}>
        <Container>
          <div className={styles['title']}>
            <Text size="h1" color="white">
              Аналитика рынка недвижимости по{NBSP}всей России с{NBSP}архивом до{NBSP}7{NBSP}лет от{NBSP}Циан
            </Text>
          </div>
          <div className={styles['description']}>
            <Text color="white">
              Предоставляем данные для принятия решений и{NBSP}оценки рынка. Для застройщиков, банков и{NBSP}всех, кто
              работает с{NBSP}недвижимостью
            </Text>
          </div>
          <div ref={this.controlsRef} className={styles['controls']}>
            {this.props.isVisibleForm && (
              <Button
                onClick={() => {
                  this.props.scrollToFeedback();
                  trackLeaveClick();
                }}
                theme="fill_white_primary"
                size="M"
              >
                Оставить заявку
              </Button>
            )}
            <Button
              onClick={() => {
                trackDownloadClick();
                window.open(
                  'https://static.cdn-cian.ru/frontend/collections-assets/valuation-b2b/Cian_Data_demo_b2b.xlsx',
                );
              }}
              beforeIcon={<img src={excel} alt="" />}
              theme="fill_white_secondary"
              size="M"
            >
              Скачать пример данных
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  private scrollHandler = () => {
    const controls = this.controlsRef.current;
    const { isVisibleStickHeader, isVisibleStickBottom, feedbackTopPosition, feedbackHeight } = this.props;

    /**
     * Скрывает стик шапку, если доскролили до середины формы обратной связи
     */
    if (window.pageYOffset + window.innerHeight >= feedbackTopPosition + feedbackHeight / 2) {
      if (isVisibleStickHeader) {
        this.props.setVisibleStickHeader(false);
      }

      return;
    }

    if (controls) {
      /**
       * Показывается стик шапку, если кнопки в hero блок скрылись за экран
       */
      if (
        controls.getBoundingClientRect().top <= 0 &&
        Math.abs(controls.getBoundingClientRect().top) >= controls.offsetHeight &&
        (!isVisibleStickHeader || !isVisibleStickBottom)
      ) {
        this.props.setVisibleStickHeader(true);
        this.props.setVisibleStickBottom(true);

        return;
      }

      /**
       * Скрывается стик шапка, если кнопки в hero блоке появились на экране
       */
      if (controls.getBoundingClientRect().top >= 0 && (isVisibleStickHeader || isVisibleStickBottom)) {
        this.props.setVisibleStickHeader(false);
        this.props.setVisibleStickBottom(false);

        return;
      }
    }
  };

  private handleScroll = throttle(this.scrollHandler, 150);
}
